export default {
  'home-title': 'テスト',
  'home-title-drone': 'ドローンパイロット',
  'home-title-company': 'カンパニー',
  'home-title-tenant': 'テナント',
  'home-title-sony': 'SONY',
}
